import React from "react";
import { Button, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useGetAllHiringSeasonsQuery } from "../../state/services/hiring";

// Show a table to a faculty that lists hiring seasons.
// The faculty can select a hiring season to view all the applications!
function HiringSeasonTable(_props) {
  const history = useHistory();

  const {
    data: hiringSeasons,
    isError,
    isLoading,
  } = useGetAllHiringSeasonsQuery();

  return (
    <div className="section container text-left">
      <h3>Hiring Seasons</h3>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th style={{ width: "33%" }}>Year</th>
            <th style={{ width: "33%" }}>Term</th>
            <th style={{ width: "33%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {!isError &&
            !isLoading &&
            Array.isArray(hiringSeasons) &&
            hiringSeasons.map((season, index) => {
              return (
                <tr key={index}>
                  <td className="align-middle">{season.year}</td>
                  <td className="align-middle">{season.term}</td>
                  <td className="align-middle">
                    <Button
                      variant="primary"
                      block
                      size="sm"
                      onClick={() => {
                        history.push(
                          `/applications?year=${season.year}&term=${season.term}`
                        );
                      }}
                    >
                      Review Applications
                    </Button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
}

export default HiringSeasonTable;
